import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentValueService } from '../../services/current-value.service';
import { VisitorService } from '../../services/visitor.service';
import { Visit } from '../../models/visit.model';
import { VisitService } from '../../services/visit.service';

@Component({
  selector: 'app-birthday-details',
  templateUrl: './birthday-details.component.html',
  styleUrls: ['./birthday-details.component.scss'],
})
export class BirthdayDetailsComponent implements OnInit {
  birthday: any;
  pageSize: number = 2147483647;
  paginationSettings = { totalItems: 0 };
  currentPage: number = 1;
  itemsPerPage: number = 2147483647;
  visits: Visit[];
  parentIdQuery: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private currentValue: CurrentValueService,
    private visitorService: VisitorService,
    private visitService: VisitService,
  ) { }


  ngOnInit() {
    this.birthday = this.currentValue.get('birthday');
    const urlVisitorId = Number(this.route.snapshot.paramMap.get('visitorId'));
    const urlBirthdayId = Number(this.route.snapshot.paramMap.get('birthdayId'));

    this.loadVisit(urlVisitorId);
    if (!this.birthday || this.birthday?.visitorId !== urlVisitorId || this.birthday?.id !== urlBirthdayId) {
      this.router.navigate(['/admin/birthdays']);
      return;
    }
  }

  downloadSignature(visitorSignatureUrl: string, fullName?: string, phone?: string) {
    const guid = visitorSignatureUrl.split('Signature/')[1];
    this.visitorService.getSignature(guid).subscribe(res => {
      const source = URL.createObjectURL(res);
      const el = document.createElement("a");
      el.setAttribute("href", source);
      el.setAttribute("download", `${fullName.replace(/\s/g, '_')}${phone}`);
      document.body.appendChild(el);
      el.click();
      el.remove();
    })
  }

  loadVisit(visitorId: number) {
    this.currentPage = 1;
    this.visitService.getAllVisitsByParentId({
      currentPage: this.currentPage,
      itemsPerPage: this.itemsPerPage,
      parentIdQuery: visitorId.toString(),
    }).subscribe(({ visits, pagination }) => {
      this.visits = visits;
      this.paginationSettings = pagination;

    });
  }

  formatDateForInput(date: Date | string): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  getCardType(value: number, hours: number): string {
    if (value === 0) {
      if (hours) {
        return 'Sat(' + hours + 'h' + ')';
      } else {
        return 'Sat';
      }
    } else if (value === 1) {
      return 'Poludnevna karta';
    } else if (value === 2) {
      return 'Dnevna karta';
    } else {
      if (hours) {
        return 'Sat(' + hours + 'h' + ')';
      } else {
        return '';
      }
    }
  }


  getLocalTimeFromServer(serverTime: string | Date): string {
  if (!serverTime) return '';

  let utcString = typeof serverTime === 'string' ? serverTime : serverTime.toString();

 
  if (!utcString.endsWith('Z')) {
    utcString += 'Z';
  }

  const date = new Date(utcString);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${hours}:${minutes}`;
}

}